export default __webpack_public_path__ + "static/media/colecao.f3643921.webp";